<template>
  <section>
    <gs-header title="Quản lý user">
      <router-link :to="{ name: 'new-user' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="clientTable" :table-name="clientTable" data-source="clients" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">

        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border style="width: 100%">
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[clientTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[clientTable].current_page - 1) * dataPaginations[clientTable].per_page) }}</small>
              </template>
            </el-table-column>

            <el-table-column label="Tài khoản" width="200">
              <template slot-scope="scope">
                <p v-if="scope.row.id"><span class="shipment-code-display click-copy">{{ scope.row.id }}</span></p>
                <p>
                  <el-tooltip placement="top" content="Ngày tạo" class="display-inline">
                    <span>{{ scope.row.created_at }}</span>
                  </el-tooltip>
                </p>
                <p>
                  <el-tooltip placement="top" content="Thời gian đăng nhập cuối cùng" class="display-inline">
                    <span>{{ scope.row.updated_at }}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column label="Thông Tin">
              <template slot-scope="scope">
                <div class="text-grey">
                  <p v-if="scope.row.name"><i aria-hidden="true" class="fa fa-user"></i> <span
                      class="click-copy">{{ scope.row.name }}</span></p>
                  <p v-if="scope.row.phone"><i aria-hidden="true" class="fa fa-phone"></i> <span
                      class="click-copy">{{ scope.row.phone }}</span></p>
                  <p v-if="scope.row.email"><i aria-hidden="true" class="fa fa-envelope"></i> <span
                      class="click-copy">{{ scope.row.email }}</span></p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="Trạng thái">
              <template slot-scope="scope">
                <p class="text-center">
                  <el-tag :type="scope.row.is_online ? 'success' : 'gray'">{{ scope.row.is_online ? 'Online' :
                    'Offline' }}</el-tag>
                </p>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <!-- <el-tooltip placement="top" content="Sửa" class="display-inline">
                    <router-link class="text-orange padding-all display-inline-block" :to="{name: 'edit-user', params: {id: scope.row.id}}"><i class="fa fa-pencil-square-o"></i></router-link>
                  </el-tooltip> -->
                  <el-tooltip placement="top" content="Offline" class="display-inline" v-if="scope.row.is_online">
                    <a @click.prevent="toggleOffline(scope.row)"
                      class="text-grey padding-all display-inline-block cursor-pointer"><i class="fa fa fa-wifi"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Online" class="display-inline" v-if="!scope.row.is_online">
                    <a @click.prevent="toggleOnline(scope.row)"
                      class="text-green padding-all display-inline-block cursor-pointer"><i class="fa fa fa-wifi"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline">
                    <a @click.prevent="deleteUser(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Phân quyền" class="display-inline">
                    <a @click.prevent="shieldUser(scope.row)"
                      class="text-green padding-all display-inline-block cursor-pointer"><i class="fa fa-shield"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
      <el-dialog :title="'Phân quyền cho user :: ' + currentUser.name" :visible.sync="shieldModal">
        <el-form label-width="0">
          <el-form-item label="Quyền">
            <el-select class="width-100" v-model="admin.roles" multiple filterable placeholder="Chọn quyền">
              <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addRole">Lưu lại </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { debounce, head, forEach } from 'lodash'
import ls from 'local-storage'
import { deleteUser, editUser, getUser } from 'src/api/users'
import { updateStatusOnline } from 'src/api/accounts'
export default {

  name: 'User',

  data() {
    return {
      clientTable: 'clients',
      filters: {
        sort: 'created_at:-1',
        role_name: 'admin'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      shieldModal: false,
      currentUser: {},
      admin: {
        roles: []
      }
    }
  },
  computed: {
    ...mapGetters('role', ['roles'])
  },
  methods: {
    ...mapActions('role', ['getAllRoles']),
    removeFilter() {
      this.reloadGsTable(this.clientTable)
      this.filters = {
        sort: 'created_at:-1',
        role_name: 'admin'
      }
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.clientTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.clientTable)
      }
    }, 300),
    deleteUser(user) {
      this.currentUser = user
      this.$confirm(`Bạn chắc chắn muốn xóa user ${this.currentUser.id}`, 'Xóa user', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delUser()
      }).catch(() => {

      })
    },
    delUser() {
      deleteUser(this.currentUser.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa user thành công'
          })
          this.reloadGsTable(this.clientTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa user thất bại'
          })
        }
      })
    },
    shieldUser(user) {
      this.admin.roles = []
      this.toggleLoadding(true)
      getUser(user.id, { include: 'roles' }).then(response => {
        switch (response.code) {
          case 200:
            this.currentUser = response.data
            this.shieldModal = true
            forEach(response.data.roles.data, (role) => {
              this.admin.roles.push(role.id)
            })
            this.toggleLoadding(false)
            break
          case 404:
            this.toggleLoadding(false)
            this.$store.dispatch('showNotify', {
              title: 'Không tìm thấy tài nguyên',
              body: 'User không tồn tại trên hệ thống',
              type: 'warning'
            }, { root: true })
            break
          default:
            this.toggleLoadding(false)
        }
      })
    },
    addRole() {
      editUser(this.currentUser.id, this.admin).then(response => {
        switch (response.code) {
          case 200:
            this.$store.dispatch('showNotify', {
              title: 'Phân quyền thành công',
              body: 'Phân quyền user  thành công'
            })
            this.shieldModal = false
            this.reloadGsTable(this.clientTable)
            this.toggleLoadding(false)
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              body: message,
              type: 'warning'
            })
            this.toggleLoadding(false)
            break
          default:
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              body: 'Phân quyền user thất bại vui lòng kiểm tra lại thông tin',
              type: 'warning'
            })
            this.toggleLoadding(false)
        }
      })
    },
    toggleOnline(data) {
      this.$store.dispatch('toggleLoadding', true, { root: true })
      let dataClient = Object.assign({}, data)
      let params = {
        is_online: 1,
        user_id: dataClient.id
      }
      let message = 'Kích hoạt online tài khoản thành công'
      this.updateStatusUser(params, message)
    },
    toggleOffline(data) {
      this.$store.dispatch('toggleLoadding', true, { root: true })
      let dataClient = Object.assign({}, data)
      let params = {
        is_online: 0,
        user_id: dataClient.id
      }
      let message = 'Kích hoạt offline tài khoản thành công'
      this.updateStatusUser(params, message)
    },
    updateStatusUser(data, message) {
      updateStatusOnline(data).then(response => {
        if (response.code === 200) {
          this.$store.dispatch('toggleLoadding', false, { root: true })
          this.$store.dispatch('showNotify', {
            title: 'Cập nhật thành công',
            body: message
          })
          this.reloadGsTable(this.clientTable)
        }
        if (response.code === 422) {
          this.$store.dispatch('toggleLoadding', false, { root: true })
          let er = response.data.errors
          let message = head(er)
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            body: message,
            type: 'warning'
          })
        }
      })
    }
  },
  mounted() {
    this.clickToCopy()
    if (ls.get('filters') && ls.get('filters')[this.clientTable]) {
      this.filters = ls.get('filters')[this.clientTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    if (!this.roles.length) {
      this.getAllRoles({ limit: -1, sort: 'name:1' })
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.clientTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['clients']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// User.vue?4ae199ba